import deepmerge from 'deepmerge'
import * as C from '@/consts'
import * as time from '@/libs/time'
import * as config from './config'
import { init } from './state'

export default {
  /**
   * 入会情報をクリアする
   *
   * @param {State} state
   */
  clear (state) {
    const data = deepmerge(init, {})
    for (const k in data) {
      state[k] = data[k]
    }
  },

  /**
   * 入会情報をクリアする
   *
   * @param {State} state
   */
  init (state) {
    // クリアデータを準備する
    const thisYear = new Date().getFullYear()
    const birthyear = thisYear - C.AGE_MIN

    const data = deepmerge(init, {
      profile: {
        // 性別: 男性
        // 誕生日: 最年少の 1 月 1 日
        gender: C.MALE,
        birthday: `${birthyear}-01-01`
      },

      license: {
        // 免許証取得日: 今年の 1 月 1 日
        // 免許証有効期限: 今年の 1 月 1 日
        acquire: `${thisYear}-01-01`,
        expire: `${thisYear}-01-01`
      },

      // 入会開始時刻を設定する
      timeLimit: Date.now() + (config.TIMEOUT * time.MINUTE)
    })

    for (const k in data) {
      state[k] = data[k]
    }
  },

  /**
   * 許諾同意を設定する
   *
   * @param {State} state
   * @param {Boolean} agreed 許諾に同意した
   */
  setAgreed (state, agreed) {
    state.agreed = agreed
  },

  /**
   * メールアドレスを設定する
   *
   * @param {State} state
   * @param {String} email メールアドレス
   */
  setEmail (state, email) {
    state.account.email = email
  },

  /**
   * パスワードを設定する
   *
   * @param {State} state
   * @param {String} password パスワード
   */
  setPassword (state, password) {
    state.account.password = password
  },

  /**
   * 個人情報を設定する
   *
   * @param {State} state
   * @param {Object} profile 個人情報
   */
  setProfile (state, profile) {
    state.profile = deepmerge(init.profile, profile)

    // 誕生日から免許証の有効期限の月日を変更する
    const birthday = time.create(state.profile.birthday)
    const expire = time.create(state.license.expire)
    expire.setMonth(birthday.getMonth() + 1, birthday.getDate())
    state.license.expire = time.format('Y-m-d', expire)
  },

  /**
   * 免許証情報を設定する
   *
   * @param {State} state
   * @param {Object} license 免許証情報
   */
  setLicense (state, license) {
    state.license = deepmerge(init.license, license)
  },

  /**
   * 同意情報を設定する
   *
   * @param {State} state
   * @param {Object} optins 同意情報
   */
  setOptins (state, optins) {
    state.optins = deepmerge(init.optins, optins)
  },

  /**
   * 登録結果を設定する
   *
   * @param {State} state
   * @param {Object} result 登録結果
   */
  setResult (state, result) {
    state.result = result
  }
}
